/* AE (NA fixes, 8 Oct 2026; delivery times updated 27 Oct 2026): delivery wording follows the shopper's country.
   Everyone sees only their own region's delivery time (not Europe's next to theirs), and US/Canadian
   shoppers read "shipping" and "business days". Text-only swaps in the page and cart drawer. */
(function () {
  var EU = 'AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,DE,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SE,GB,CH,NO,IS,LI,MC,AD,IM,JE,GG'.split(',');
  var cc = (window.Shopify && Shopify.country) || '';
  var na = cc === 'US' || cc === 'CA';
  /* AE (27 Oct 2026): Airventory delivery times from Nov 2026, carrier transit after the 1–3 working days
     to make the order. [low, high, working days?]: Germany-shipped countries count working days,
     China-shipped countries count calendar days (couriers deliver 7 days a week). Same table as the
     "Delivery estimate" block in the product templates and the Standard rates in Settings > Shipping. */
  var region = /Tracked delivery then takes 2–6 working days within Europe, 7–12 days to the US, 7–9 to Canada, 6–9 to Australia and 7–14 to the rest of the world\./;
  var T = { GB: [4, 5, 1], GI: [4, 5, 1], GG: [4, 5, 1], IM: [4, 5, 1], JE: [4, 5, 1], DK: [4, 5, 1], HR: [4, 5, 1], RO: [4, 5, 1],
    DE: [3, 4, 1], FR: [3, 4, 1], IT: [3, 4, 1], ES: [3, 4, 1], AT: [3, 4, 1], CZ: [3, 4, 1], PT: [3, 4, 1],
    BE: [2, 3, 1], PL: [2, 3, 1], HU: [2, 3, 1], GR: [5, 6, 1],
    US: [7, 12, 0], CA: [7, 9, 0], AU: [6, 9, 0], AE: [5, 7, 0] };
  var rules = [];
  if (cc) {
    var t = T[cc] || (EU.indexOf(cc) > -1 || ['SM', 'VA'].indexOf(cc) > -1 ? [3, 6, 1] : [7, 14, 0]);
    var span = t[0] + '–' + t[1] + (t[2] ? (na ? ' business days' : ' working days') : ' days');
    if (cc === 'US') rules.push([region, 'Tracked shipping to the US then takes ' + span + '.']);
    else if (cc === 'CA') rules.push([region, 'Tracked shipping to Canada then takes ' + span + '.']);
    else rules.push([region, 'Tracked delivery then takes ' + span + '.']);
  }
  if (na) {
    rules.push([/Free delivery on 2\+ pieces/g, 'Free shipping on 2+ pieces']);
    rules.push([/Free delivery on 2 or more pieces/g, 'Free shipping on 2 or more pieces']);
    rules.push([/dispatched (in|within) 1–3 working days/g, 'ships $1 1–3 business days']);
    rules.push([/your delivery is free/g, 'your shipping is free']);
    rules.push([/Your delivery is free\./g, 'Your shipping is free.']);
    rules.push([/for free delivery\./g, 'for free shipping.']);
    rules.push([/Delivery & returns/g, 'Shipping & returns']);
    rules.push([/Delivery included\./g, 'Shipping included.']);
  }
  if (!rules.length) return;
  var TEST = /[Dd]elivery|working days/;
  function run() {
    var roots = document.querySelectorAll('main, cart-drawer-component, .cart-drawer');
    for (var r = 0; r < roots.length; r++) {
      var tw = document.createTreeWalker(roots[r], NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = tw.nextNode())) {
        var v = n.nodeValue;
        if (!TEST.test(v)) continue;
        if (n.parentElement && n.parentElement.closest('script, style, template')) continue;
        for (var i = 0; i < rules.length; i++) v = v.replace(rules[i][0], rules[i][1]);
        if (v !== n.nodeValue) n.nodeValue = v;
      }
    }
  }
  var queued = false;
  function schedule() { if (queued) return; queued = true; setTimeout(function () { queued = false; run(); }, 50); }
  function boot() { run(); new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
